import { createOfferMachineHooks } from '@eneco/flows/hooks';

import { FlowConsumerContextEnergy } from '../../context';
import { getOfferEventHash } from '../machines/getOffer/getOffer.helpers';
import { getOfferMachine } from '../machines/getOffer/getOffer.machine';
import { OfferMachineEvent, OfferResponse } from '../types';

export const { useOfferMachine, useCachedOfferMachine } = createOfferMachineHooks<
  OfferResponse,
  FlowConsumerContextEnergy,
  OfferMachineEvent
>({
  getOfferMachine,
  getOfferEventHash,
});
